const baseAPIURL = 'api' 

export default baseAPIURL;